<template>
  <div class="box_img">
    <form-header :name="'获取方法：'" :label="'上传图片后复制网络地址'"></form-header>
    <uploadFile type="image"></uploadFile>
  </div>
</template>
<script>
import formHeader from "@/views/components/common/form/formHeader.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";

export default {
  extends: "",
  components: {
    formHeader,
    uploadFile,
  },
  props: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped></style>
